// @flow
const RemotePlayerType: {[type: string]: string} = {
  CHROMECAST: 'chromecast'
};

export {RemotePlayerType};
